(function(window, angular){'use strict';

var ngModule = angular.module('pp.ui.services.shares-order-liquidity-dialog', ['pp.services.core', 'pp.services.dialog', 'pp.widgets.shares-order-liquidity-details']);

/**
 * @ndgoc service
 * @description
 * checks if we need to notify the user that they have been qualified/disqualified for an rff scheme
 * shows the dialog and sets a preference when the user dismisses it
 * so that the dialog is never shown again for the same scheme
 */
ngModule.service('sharesOrderLiquidityDialogService', ['$rootScope', 'ppTrack', 'dialogService', function ($rootScope, ppTrack, dialogService) {

    // -- util functions

    // create a scope, show the dialog
    // tracks dialog dismissed and sets the preference to never show the dialog again (for this scheme)
    function showDialog(symbol) {
        var scope = $rootScope.$new();
        var options = {
            clickClose: true,
            escapeClose: true,
            showClose: true,
            scope: scope,
            classNames: 'shares-order-liquidity-dialog-modal',
        };
        scope.symbol = symbol;
        options.contents = '<div pp-shares-order-liquidity-details="symbol"></div>';

        return dialogService.show(options);
    }

    // -- api

    var api = {};

    api.show = function (symbol) {
        showDialog(symbol).then(function () {
            ppTrack.action('shares-order-liquidity.dismiss');
        });
    };

    return api;
}]);
})(window, window.angular);